/* Glowlora COD checkout popup (Shopify) - v1.1 (coupons)
   Opens from: product-page "Cash on delivery" button, cart / cart-drawer checkout buttons.
   Sends the order to GLW_COD_CFG.endpoint (Google Apps Script) which re-prices and creates the Shopify order. */
(function () {
  'use strict';
  var CFG = window.GLW_COD_CFG || {};
  var ENDPOINT = String(CFG.endpoint || '');
  if (ENDPOINT.indexOf('https://') !== 0) { return; }          // not configured -> leave the store untouched
  var CUR = CFG.currency || 'BDT';
  var RATES = CFG.rates || { city: 70, upazila: 110, outside: 130 };
  var FREE_AT = Number(CFG.free_at === undefined ? 3000 : CFG.free_at);
  var TIERS = CFG.tiers || [[3, 15], [2, 10]];
  var WA = CFG.whatsapp || '';
  var UPZ = ['Savar', 'Dhamrai', 'Keraniganj', 'Nawabganj', 'Dohar'];
  var GEO_RAW = window.GLW_GEO || [];
  var GEO = GEO_RAW.map(function (r) {
    return { n: r[0], b: r[1], t: r[2].split(';').map(function (x) { var p = x.split('|'); return { n: p[0], b: p[1] }; }) };
  });
  var S = { items: [], src: '', busy: false, dist: null, thana: null, t0: 0, eid: '', built: false, done: false, rule: null };
  var root, dlg;

  document.documentElement.classList.add('glwc-on');

  /* ---------- tiny helpers ---------- */
  function $(s) { return dlg.querySelector(s); }
  function $$(s) { return Array.prototype.slice.call(dlg.querySelectorAll(s)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = (s === null || s === undefined) ? '' : String(s); return d.innerHTML; }
  function fmt(n) { return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function money(n) { return 'Tk ' + fmt(n); }
  function r2(n) { return Math.round(n * 100) / 100; }
  function toEn(s) { var bn = '০১২৩৪৫৬৭৮৯'; return String(s).replace(/[০-৯]/g, function (c) { return String(bn.indexOf(c)); }); }
  function bnNum(n) { return String(n); }   /* English digits - the Bengali digit 1 looks like a danda in this font */
  function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
  function ss(k, v) { try { if (v === undefined) { return sessionStorage.getItem(k) || ''; } if (!sessionStorage.getItem(k)) { sessionStorage.setItem(k, v); } } catch (e) { } return ''; }
  function img(u, w) { if (!u) { return ''; } u = String(u); if (u.indexOf('//') === 0) { u = 'https:' + u; } return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 160); }
  function zoneOf(d, t) {
    if (d === 'Dhaka') { return UPZ.indexOf(t) === -1 ? 'city' : 'upazila'; }
    if (d === 'Gazipur' || d === 'Narayanganj') { return 'upazila'; }
    return 'outside';
  }
  function tierPct(q) { for (var i = 0; i < TIERS.length; i++) { if (q >= TIERS[i][0]) { return TIERS[i][1]; } } return 0; }
  function eventId() { return 'e' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }

  /* first-touch attribution kept for the session */
  (function () {
    var u = new URLSearchParams(location.search), s = u.get('utm_source');
    if (!s && u.get('fbclid')) { s = 'facebook'; }
    if (!s) {
      var r = document.referrer || '';
      if (!r) { s = 'Direct'; } else { try { s = (new URL(r).hostname === location.hostname) ? '' : 'Referral'; } catch (e) { s = 'Referral'; } }
    }
    if (s) { ss('glwc_src', s); }
    ss('glwc_land', location.href);
    ss('glwc_ref', document.referrer || '');
  })();

  /* ---------- tracking ---------- */
  function track(kind, d) {
    try {
      var ids = d.items.map(function (i) { return String(i.id); });
      var contents = d.items.map(function (i) { return { id: String(i.id), quantity: i.qty }; });
      var base = { value: d.value, currency: CUR, content_ids: ids, contents: contents, content_type: 'product', num_items: d.items.reduce(function (a, i) { return a + i.qty; }, 0) };
      if (kind === 'init') {
        if (window.fbq) { window.fbq('track', 'InitiateCheckout', base); }
        if (window.dataLayer) { window.dataLayer.push({ event: 'begin_checkout', ecommerce: { currency: CUR, value: d.value, items: d.items.map(function (i) { return { item_id: String(i.id), item_name: i.name, quantity: i.qty, price: i.unit }; }) } }); }
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) { window.Shopify.analytics.publish('glw_cod_initiate_checkout', base); }
      } else {
        if (window.fbq) { window.fbq('track', 'Purchase', base, { eventID: d.event_id }); }
        if (window.dataLayer) { window.dataLayer.push({ event: 'purchase', ecommerce: { transaction_id: d.order, currency: CUR, value: d.value, shipping: d.shipping, items: d.items.map(function (i) { return { item_id: String(i.id), item_name: i.name, quantity: i.qty, price: i.unit }; }) } }); }
        if (window.gtag) { window.gtag('event', 'purchase', { transaction_id: d.order, currency: CUR, value: d.value, shipping: d.shipping }); }
        var p = {}; for (var k in base) { p[k] = base[k]; } p.order = d.order; p.event_id = d.event_id;
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) { window.Shopify.analytics.publish('glw_cod_purchase', p); }
      }
    } catch (e) { }
  }

  /* ---------- build the dialog (once) ---------- */
  function build() {
    if (S.built) { return; }
    S.built = true;
    var f = document.createElement('link');
    f.rel = 'stylesheet'; f.href = 'https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@500;600;700&display=swap';
    document.head.appendChild(f);
    root = document.createElement('div');
    root.className = 'glwc-ov'; root.id = 'glwc';
    root.innerHTML =
      '<svg width="0" height="0" style="position:absolute" aria-hidden="true"><defs>' +
      '<symbol id="gi-win" viewBox="0 0 24 24"><rect x="3.5" y="4.5" width="17" height="15" rx="2.5"/><path d="M3.5 9.5h17M7.5 7h.01"/></symbol>' +
      '<symbol id="gi-x" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></symbol>' +
      '<symbol id="gi-pen" viewBox="0 0 24 24"><path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3zM14.5 7.5l3 3"/></symbol>' +
      '<symbol id="gi-tel" viewBox="0 0 24 24"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/></symbol>' +
      '<symbol id="gi-pin" viewBox="0 0 24 24"><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.6"/></symbol>' +
      '<symbol id="gi-bld" viewBox="0 0 24 24"><rect x="5" y="3.5" width="14" height="17" rx="2"/><path d="M9 8h.01M12 8h.01M15 8h.01M9 12h.01M12 12h.01M15 12h.01M10 20.5v-3.5h4v3.5"/></symbol>' +
      '<symbol id="gi-cart" viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M3 4h2.4l2.2 11h10.2L20 7.5H6.2"/></symbol>' +
      '<symbol id="gi-bin" viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12.5A1.5 1.5 0 0 0 8.5 21h7a1.5 1.5 0 0 0 1.5-1.5L18 7M9 7V4.5h6V7"/></symbol>' +
      '<symbol id="gi-ok" viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></symbol>' +
      '<symbol id="gi-tag" viewBox="0 0 24 24"><path d="M3 12.2V4h8.2L21 13.8 13.8 21 3 12.2z"/><circle cx="7.6" cy="8.6" r="1.2"/></symbol>' +
      '</defs></svg>' +
      '<div class="glw-co glwc-dlg" role="dialog" aria-modal="true" aria-labelledby="glw-title">' +
      '<form class="glw-card" id="glw-form" novalidate autocomplete="off">' +
      '<div class="glw-head"><span class="glw-head-ic"><svg class="i" width="20" height="20"><use href="#gi-win"/></svg></span><span class="glw-head-tx"><strong id="glw-title">ক্যাশ অন ডেলিভারিতে অর্ডার করুন</strong><small>আপনার বিস্তারিত তথ্য দিন</small></span><button type="button" class="glw-x" data-close aria-label="Close"><svg class="i" width="18" height="18"><use href="#gi-x"/></svg></button></div>' +
      '<div class="glw-body">' +
      '<div class="glw-msg" id="glw-loading">লোড হচ্ছে…</div>' +
      '<div class="glw-msg" id="glw-empty" hidden><p>আপনার কার্ট খালি আছে।</p><button type="button" class="glw-lnk" data-close>শপিং চালিয়ে যান</button></div>' +
      '<div id="glw-fields" hidden>' +
      '<div class="glw-f"><label class="glw-l" for="glw-name">নাম <b>*</b></label><div class="glw-in"><span class="glw-ic"><svg class="i"><use href="#gi-pen"/></svg></span><input type="text" id="glw-name" placeholder="নাম" autocomplete="name" maxlength="80"></div><div class="glw-err" data-for="name"></div></div>' +
      '<div class="glw-f"><label class="glw-l" for="glw-phone">মোবাইল নম্বর <b>*</b></label><div class="glw-in"><span class="glw-ic"><svg class="i"><use href="#gi-tel"/></svg></span><input type="tel" id="glw-phone" inputmode="numeric" placeholder="01XXXXXXXXX (বাংলাদেশি নম্বর)" autocomplete="tel" maxlength="20"></div><div class="glw-err" data-for="phone"></div></div>' +
      '<div class="glw-f"><label class="glw-l" for="glw-address">সম্পূর্ণ ঠিকানা <b>*</b></label><div class="glw-in glw-ta"><span class="glw-ic"><svg class="i"><use href="#gi-pin"/></svg></span><textarea id="glw-address" rows="2" placeholder="আপনার জেলা, থানা ও বিস্তারিত ঠিকানা" autocomplete="street-address"></textarea></div><div class="glw-err" data-for="address"></div></div>' +
      '<div class="glw-f"><label class="glw-l" for="glw-district">District / জেলা <b>*</b></label><div class="glw-dd" id="glw-dd-district"><div class="glw-in"><span class="glw-ic"><svg class="i"><use href="#gi-bld"/></svg></span><input type="text" id="glw-district" placeholder="Select district" autocomplete="off" role="combobox" aria-expanded="false"></div><ul class="glw-list" hidden></ul></div><div class="glw-err" data-for="district"></div></div>' +
      '<div class="glw-f"><label class="glw-l" for="glw-thana">Thana / থানা <b>*</b></label><div class="glw-dd" id="glw-dd-thana"><div class="glw-in"><span class="glw-ic"><svg class="i"><use href="#gi-bld"/></svg></span><input type="text" id="glw-thana" placeholder="Select thana" autocomplete="off" role="combobox" aria-expanded="false"></div><ul class="glw-list" hidden></ul></div><div class="glw-err" data-for="thana"></div></div>' +
      '<div id="glw-items" class="glw-items"></div>' +
      '<div class="glw-cp" id="glw-cp"><div class="glw-cp-row"><div class="glw-in glw-cp-in"><span class="glw-ic"><svg class="i"><use href="#gi-tag"/></svg></span><input type="text" id="glw-coupon" placeholder="কুপন কোড" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="40"></div><button type="button" class="glw-cp-btn" id="glw-cp-apply">প্রয়োগ করুন</button></div><div class="glw-cp-chip"><svg class="i" width="18" height="18"><use href="#gi-ok"/></svg><b id="glw-cp-code"></b><button type="button" id="glw-cp-rm">সরান</button></div><div class="glw-cp-msg" id="glw-cp-msg" hidden></div></div>' +
      '<div class="glw-sec"><div class="glw-sec-t">ডেলিভারি চার্জ</div><div class="glw-hint" id="glw-hint">Select your District &amp; Thana to see the delivery charge.</div>' +
      '<div class="glw-zones" role="radiogroup" aria-label="ডেলিভারি চার্জ">' +
      '<div class="glw-zone" data-zone="city" role="radio" aria-checked="false"><span class="glw-radio"></span><span class="glw-zone-n">ঢাকা সিটি</span><span class="glw-zone-p"></span></div>' +
      '<div class="glw-zone" data-zone="upazila" role="radio" aria-checked="false"><span class="glw-radio"></span><span class="glw-zone-n">ঢাকা উপজেলা</span><span class="glw-zone-p"></span></div>' +
      '<div class="glw-zone" data-zone="outside" role="radio" aria-checked="false"><span class="glw-radio"></span><span class="glw-zone-n">ঢাকার বাইরে</span><span class="glw-zone-p"></span></div>' +
      '</div><div class="glw-freehint" id="glw-freehint"></div></div>' +
      '<div class="glw-sum"><div class="glw-sum-r"><span>Subtotal</span><span id="glw-sub">Tk 0.00</span></div><div class="glw-sum-r glw-sum-d" id="glw-disc-row" hidden><span id="glw-disc-l">Discount</span><span id="glw-disc">−Tk 0.00</span></div><div class="glw-sum-r glw-sum-d" id="glw-cpd-row" hidden><span id="glw-cpd-l">Coupon</span><span id="glw-cpd">−Tk 0.00</span></div><div class="glw-sum-r"><span>Shipping</span><span id="glw-ship">—</span></div><div class="glw-sum-r glw-sum-t"><span>Total</span><span id="glw-total">Tk 0.00</span></div></div>' +
      '<div class="glw-f"><label class="glw-l" for="glw-note">নোট</label><div class="glw-in glw-note"><textarea id="glw-note" rows="3" maxlength="300"></textarea></div></div>' +
      '<input type="text" id="glw-hp" value="" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;opacity:0;height:0;width:0">' +
      '</div></div>' +
      '<div class="glw-foot" id="glw-foot" hidden><div class="glw-ferr" id="glw-ferr" hidden></div><button type="submit" class="glw-submit" id="glw-submit"><svg class="i"><use href="#gi-cart"/></svg><span id="glw-submit-t">অর্ডার নিশ্চিত করুন — TK 0.00</span></button><div class="glw-foot-n">Cash on delivery — pay when you receive your order</div></div>' +
      '</form>' +
      '<div class="glw-card glw-ty" id="glw-ty" hidden></div>' +
      '</div>';
    document.body.appendChild(root);
    dlg = root.querySelector('.glwc-dlg');
    wire();
  }

  /* ---------- errors ---------- */
  function setErr(f, m) {
    var b = dlg.querySelector('.glw-err[data-for="' + f + '"]');
    if (!b) { return; }
    b.textContent = m || '';
    if (m) { b.parentNode.classList.add('glw-bad'); } else { b.parentNode.classList.remove('glw-bad'); }
  }
  function clearErrs() {
    $$('.glw-err').forEach(function (b) { b.textContent = ''; });
    $$('.glw-bad').forEach(function (w) { w.classList.remove('glw-bad'); });
    var fe = $('#glw-ferr'); fe.hidden = true; fe.textContent = '';
  }
  function formErr(m) { var fe = $('#glw-ferr'); fe.textContent = m; fe.hidden = false; }

  /* ---------- searchable dropdown ---------- */
  function nfc(x) { x = String(x || ''); try { return x.normalize ? x.normalize('NFC') : x; } catch (e) { return x; } }
  function dropdown(sel, getItems, onPick) {
    var wrap = $(sel), input = wrap.querySelector('input'), list = wrap.querySelector('.glw-list');
    var picked = null, cur = -1, shown = [];
    function draw(q) {
      q = nfc(String(q || '').toLowerCase().trim());
      var all = getItems();
      shown = all.filter(function (it) { return q === '' ? true : (it.n.toLowerCase().indexOf(q) !== -1 ? true : nfc(it.b).indexOf(q) !== -1); });
      list.innerHTML = '';
      if (all.length === 0) { list.innerHTML = '<li class="none">প্রথমে জেলা নির্বাচন করুন</li>'; return; }
      if (shown.length === 0) { list.innerHTML = '<li class="none">কিছু পাওয়া যায়নি</li>'; return; }
      shown.forEach(function (it, i) {
        var li = document.createElement('li');
        li.innerHTML = '<span>' + esc(it.n) + '</span><i>' + esc(it.b) + '</i>';
        if (i === cur) { li.className = 'on'; }
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(it); });
        li.addEventListener('touchend', function (e) { e.preventDefault(); pick(it); });
        list.appendChild(li);
      });
    }
    function open(q) { cur = -1; draw(q); list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.value = picked ? picked.n : ''; }
    function pick(it) { picked = it; input.value = it.n; list.hidden = true; input.setAttribute('aria-expanded', 'false'); onPick(it); }
    input.addEventListener('focus', function () { open(''); });
    input.addEventListener('click', function () { if (list.hidden) { open(''); } });
    input.addEventListener('input', function () { open(input.value); });
    input.addEventListener('blur', function () { setTimeout(close, 120); });
    input.addEventListener('keydown', function (e) {
      if (list.hidden) { return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); cur = Math.min(cur + 1, shown.length - 1); draw(input.value); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); cur = Math.max(cur - 1, 0); draw(input.value); }
      else if (e.key === 'Enter') { if (cur !== -1) { if (shown[cur]) { e.preventDefault(); pick(shown[cur]); } } }
      else if (e.key === 'Escape') { e.stopPropagation(); close(); input.blur(); }
    });
    return { reset: function () { picked = null; input.value = ''; list.hidden = true; } };
  }

  /* ---------- items + totals ---------- */
  /* coupon maths - identical to the server (Apps Script) */
  function cpApply(lines) {
    var r = S.rule, eg = 0, eq = 0, ed = 0, n = 0;
    lines.forEach(function (l) {
      var ok = true;
      if (r.pids || r.vids) { ok = !!((r.pids && r.pids.indexOf(l.pid) !== -1) || (r.vids && r.vids.indexOf(l.vid) !== -1)); }
      if (ok) { eg += l.g; eq += l.q; ed += l.d; n++; }
    });
    if (r.kind !== 'ship' && n === 0) { return { ok: false, note: 'এই কুপনটি আপনার কার্টের পণ্যে প্রযোজ্য নয়।' }; }
    if (r.kind === 'ship') { eg = 0; eq = 0; lines.forEach(function (l) { eg += l.g; eq += l.q; }); }
    eg = r2(eg); ed = r2(ed);
    if (r.min_sub && eg < r.min_sub) { return { ok: false, note: 'এই কুপনের জন্য কমপক্ষে ' + money(r.min_sub) + ' এর পণ্য লাগবে।' }; }
    if (r.min_qty && eq < r.min_qty) { return { ok: false, note: 'এই কুপনের জন্য কমপক্ষে ' + r.min_qty + 'টি পণ্য লাগবে।' }; }
    if (r.kind === 'ship') { return { ok: true, ship: true, amount: 0, drop: 0 }; }
    var base = r.stack ? r2(eg - ed) : eg;
    var cd = (r.kind === 'percent') ? r2(base * r.value / 100) : (r.each ? r2(r.value * eq) : r.value);
    cd = r2(Math.min(cd, base));
    if (!r.stack) {
      if (cd <= ed) { return { ok: false, note: 'আপনার পরিমাণ-ছাড়টাই এই কুপনের চেয়ে বেশি, তাই সেটাই প্রযোজ্য।' }; }
      return { ok: true, amount: cd, drop: ed };
    }
    return { ok: true, amount: cd, drop: 0 };
  }
  function calc() {
    var gross = 0, disc = 0, lines = [];
    S.items.forEach(function (it) {
      var g = r2(it.unit * it.qty), d = r2(g * tierPct(it.qty) / 100);
      gross += g; disc += d;
      lines.push({ vid: String(it.id), pid: String(it.pid || ''), g: g, q: it.qty, d: d });
    });
    gross = r2(gross); disc = r2(disc);
    var cp = S.rule ? cpApply(lines) : null, cdisc = 0, shipFree = false;
    if (cp && cp.ok) { cdisc = cp.amount; disc = r2(disc - cp.drop); shipFree = !!cp.ship; }
    var net = r2(gross - disc - cdisc);
    var z = S.thana ? zoneOf(S.dist.n, S.thana.n) : null;
    var free = (FREE_AT > 0 && net >= FREE_AT) || shipFree;
    var ship = z ? (free ? 0 : RATES[z]) : null;
    return { gross: gross, disc: disc, cdisc: cdisc, cp: cp, net: net, zone: z, free: free, ship: ship, total: r2(net + (ship === null ? 0 : ship)) };
  }
  function nudge(q) {
    if (q === 1 && tierPct(2) > 0) { return '2টি নিলে ' + bnNum(tierPct(2)) + '% ছাড়'; }
    if (q === 2 && tierPct(3) > tierPct(2)) { return '3টি নিলে ' + bnNum(tierPct(3)) + '% ছাড়'; }
    return '';
  }
  function drawItems() {
    var h = '';
    S.items.forEach(function (it, i) {
      var p = tierPct(it.qty), n = nudge(it.qty);
      h += '<div class="glw-item" data-i="' + i + '">' +
        '<span class="glw-thumb">' + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '') + '</span>' +
        '<span class="glw-item-i"><span class="glw-item-n">' + esc(it.name) + '</span>' + (it.variant ? '<span class="glw-item-v">' + esc(it.variant) + '</span>' : '') + (p > 0 ? '<span class="glw-item-t">' + bnNum(p) + '% ছাড় প্রযোজ্য</span>' : (n ? '<span class="glw-item-n2">' + esc(n) + '</span>' : '')) + '</span>' +
        '<span class="glw-item-p">' + money(it.unit * it.qty) + '</span>' +
        '<div class="glw-item-c"><div class="glw-step"><button type="button" data-a="minus" aria-label="Decrease">−</button><span>' + it.qty + '</span><button type="button" data-a="plus" aria-label="Increase"' + (it.qty >= 50 ? ' disabled' : '') + '>+</button></div>' +
        '<button type="button" class="glw-del" data-a="del" aria-label="Remove"><svg class="i" width="17" height="17"><use href="#gi-bin"/></svg></button></div></div>';
    });
    $('#glw-items').innerHTML = h;
  }
  function totals() {
    var c = calc();
    $$('.glw-zone').forEach(function (row) {
      var k = row.getAttribute('data-zone'), on = (k === c.zone);
      row.classList.toggle('on', on);
      row.classList.toggle('free', on && c.free);
      row.setAttribute('aria-checked', on ? 'true' : 'false');
      row.querySelector('.glw-zone-p').textContent = money(RATES[k]);
    });
    $('#glw-hint').hidden = !!c.zone;
    var fh = $('#glw-freehint');
    if (FREE_AT > 0) {
      fh.hidden = false;
      fh.textContent = c.free ? '🎉 অভিনন্দন! আপনার ডেলিভারি চার্জ ফ্রি।' : ('আর ' + money(FREE_AT - c.net) + ' এর পণ্য যোগ করলে ডেলিভারি ফ্রি!');
      fh.className = 'glw-freehint' + (c.free ? ' ok' : '');
    } else { fh.hidden = true; }
    $('#glw-sub').textContent = money(c.gross);
    $('#glw-disc-row').hidden = !(c.disc > 0);
    $('#glw-disc-l').textContent = 'Quantity discount';
    $('#glw-disc').textContent = '−' + money(c.disc);
    $('#glw-cpd-row').hidden = !(c.cdisc > 0);
    $('#glw-cpd-l').textContent = 'Coupon' + (S.rule ? ' (' + S.rule.code + ')' : '');
    $('#glw-cpd').textContent = '−' + money(c.cdisc);
    cpUi(c);
    $('#glw-ship').textContent = c.ship === null ? '—' : (c.free ? 'Free' : money(c.ship));
    $('#glw-total').textContent = money(c.total);
    $('#glw-submit-t').textContent = 'অর্ডার নিশ্চিত করুন — TK ' + fmt(c.total);
  }
  function refresh() {
    if (S.items.length === 0) {
      $('#glw-fields').hidden = true; $('#glw-foot').hidden = true; $('#glw-empty').hidden = false; return;
    }
    $('#glw-empty').hidden = true; $('#glw-fields').hidden = false; $('#glw-foot').hidden = false;
    drawItems(); totals();
  }

  /* ---------- coupon box ---------- */
  function cpMsg(t, cls) { var m = $('#glw-cp-msg'); m.textContent = t || ''; m.className = 'glw-cp-msg' + (cls ? ' ' + cls : ''); m.hidden = !t; }
  function cpUi(c) {
    var box = $('#glw-cp');
    if (!S.rule) { box.classList.remove('on'); return; }
    box.classList.add('on');
    $('#glw-cp-code').textContent = S.rule.code;
    if (c.cp && !c.cp.ok) { cpMsg(c.cp.note, 'warn'); }
    else if (c.cp && c.cp.ship) { cpMsg('ফ্রি ডেলিভারি কুপন প্রয়োগ হয়েছে।', 'ok'); }
    else if (c.cp) { cpMsg('কুপন প্রয়োগ হয়েছে। আপনি ' + money(c.cdisc) + ' বাঁচাচ্ছেন।', 'ok'); }
  }
  function cpApplyClick() {
    var inp = $('#glw-coupon'), btn = $('#glw-cp-apply'), code = inp.value.trim().toUpperCase();
    if (btn.disabled) { return; }
    if (!code) { cpMsg('কুপন কোড লিখুন।'); return; }
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'যাচাই হচ্ছে…'; cpMsg('');
    send({ v: 1, action: 'coupon', code: code, hp: '' }).then(function (res) {
      btn.disabled = false; btn.textContent = old;
      if (res && res.ok && res.rule) { S.rule = res.rule; S.rule.code = code; inp.value = ''; cpMsg(''); totals(); }
      else { cpMsg((res && res.message) ? res.message : 'কুপনটি যাচাই করা যায়নি।'); }
    }).catch(function () { btn.disabled = false; btn.textContent = old; cpMsg('ইন্টারনেট সংযোগ পরীক্ষা করে আবার চেষ্টা করুন।'); });
  }

  /* ---------- data sources ---------- */
  function getJSON(u) { return fetch(u, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.json(); }); }
  /* control inside the product form, or tied to it by form="id" (the quantity box is outside the <form>) */
  function ctl(form, base) {
    var el = form ? form.querySelector(base) : null;
    var fid = form ? form.getAttribute('id') : '';
    if (!el && fid) { el = document.querySelector(base.replace('input', 'input[form="' + fid + '"]')); }
    return el;
  }
  function fromProduct(btn) {
    var form = btn.closest('form'), handle = btn.getAttribute('data-handle');
    var idEl = ctl(form, 'input[name="id"]');
    var vid = idEl ? idEl.value : btn.getAttribute('data-variant');
    var q = 1;
    var br = ctl(form, 'input[name="bundle_quantity"]:checked');
    if (br) { q = parseInt(br.value, 10) || 1; }
    else { var qi = ctl(form, 'input[name="quantity"]'); if (qi) { q = parseInt(qi.value, 10) || 1; } }
    return getJSON('/products/' + handle + '.js').then(function (p) {
      var v = null;
      p.variants.forEach(function (x) { if (String(x.id) === String(vid)) { v = x; } });
      if (!v) { v = p.variants[0]; }
      if (v.available === false) { throw new Error('soldout'); }
      var im = (v.featured_image && v.featured_image.src) ? v.featured_image.src : (p.featured_image || '');
      return [{ id: v.id, qty: q, name: p.title, variant: (v.title && v.title !== 'Default Title') ? v.title : '', img: img(im, 160), unit: v.price / 100, pid: p.id }];
    });
  }
  function fromCart() {
    return getJSON('/cart.js').then(function (c) {
      return c.items.map(function (i) {
        return { id: i.variant_id, qty: i.quantity, name: i.product_title, variant: (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '', img: img(i.image, 160), unit: (i.original_price !== undefined ? i.original_price : i.price) / 100, pid: i.product_id };
      });
    });
  }

  /* ---------- open / close ---------- */
  function lock(on) { document.documentElement.classList.toggle('glwc-lock', on); }
  function reset() {
    $('#glw-form').hidden = false; $('#glw-ty').hidden = true;
    S.dist = null; S.thana = null; S.done = false; S.busy = false; S.rule = null;
    var cpi = $('#glw-coupon'); if (cpi) { cpi.value = ''; } cpMsg('');
    ['name', 'phone', 'address', 'note', 'hp'].forEach(function (k) { var el = $('#glw-' + k); if (el) { el.value = ''; } });
    ddD.reset(); ddT.reset(); clearErrs();
    var b = $('#glw-submit'); b.disabled = false;
  }
  function open(src, btn) {
    build();
    S.src = src; S.t0 = Date.now(); S.eid = eventId();
    reset();
    root.classList.add('open'); lock(true);
    $('#glw-loading').hidden = false; $('#glw-loading').textContent = 'লোড হচ্ছে…';
    $('#glw-fields').hidden = true; $('#glw-foot').hidden = true; $('#glw-empty').hidden = true;
    var body = $('.glw-body'); if (body) { body.scrollTop = 0; }
    var p = (src === 'cart') ? fromCart() : fromProduct(btn);
    p.then(function (items) {
      S.items = items;
      $('#glw-loading').hidden = true;
      refresh();
      var c = calc();
      if (items.length) { track('init', { items: items, value: c.net }); }
    }).catch(function (err) { $('#glw-loading').textContent = (err && err.message === 'soldout') ? 'এই পণ্যটি এখন স্টকে নেই।' : 'লোড করা যায়নি। ইন্টারনেট সংযোগ পরীক্ষা করে আবার চেষ্টা করুন।'; });
  }
  function close() {
    if (!root) { return; }
    root.classList.remove('open'); lock(false);
    if (S.done && S.src === 'cart') { try { location.reload(); } catch (e) { } }
  }

  /* ---------- submit ---------- */
  /* Bangladeshi mobile numbers only: 01[3-9] + 8 digits (a +880 / 880 / 00880 prefix is accepted and removed).
     Obvious fakes (11111111, 12345678, 12121212, 12341234 ...) are refused. Same rules run again on the server. */
  var PH_FORMAT = 'সঠিক বাংলাদেশি মোবাইল নম্বর দিন (01 দিয়ে শুরু, মোট 11 সংখ্যা)।';
  var PH_FOREIGN = 'শুধু বাংলাদেশের মোবাইল নম্বর গ্রহণযোগ্য, অন্য দেশের নম্বর নয়।';
  var PH_FAKE = 'এই নম্বরটি সঠিক মনে হচ্ছে না। আপনার আসল মোবাইল নম্বর দিন।';
  var PH_START = 'বাংলাদেশের মোবাইল নম্বর 013 থেকে 019 পর্যন্ত (01 দিয়ে শুরু) হয়।';
  function fakeBd(n) {
    var s = n.slice(3), seen = {}, d = 0, i, up = 1, dn = 1, best = 1, df;
    for (i = 0; i < 8; i++) { if (!seen[s.charAt(i)]) { seen[s.charAt(i)] = 1; d++; } }
    if (d <= 2) { return true; }
    for (i = 1; i < 8; i++) {
      df = s.charCodeAt(i) - s.charCodeAt(i - 1);
      up = (df === 1) ? up + 1 : 1; dn = (df === -1) ? dn + 1 : 1;
      if (up > best) { best = up; } if (dn > best) { best = dn; }
    }
    return best >= 6 || s.slice(0, 4) === s.slice(4);
  }
  function bdPhone(raw) {
    var p = toEn(raw).replace(/[\s()\-.]+/g, ''), m = p.match(/^(?:(?:\+|00)?88)?(01[3-9][0-9]{8})$/);
    if (!m) { return { ok: false, msg: (/^(\+|00)/.test(p) && !/^(\+|00)88/.test(p)) ? PH_FOREIGN : PH_FORMAT }; }
    if (fakeBd(m[1])) { return { ok: false, msg: PH_FAKE }; }
    return { ok: true, phone: m[1] };
  }
  /* message while typing - only the clear mistakes (wrong first digits / fake 11-digit number) */
  function phLive(v) {
    var c = v.charAt(0);
    if (!v || c === '+') { return ''; }
    if (c === '0' && v.charAt(1) !== '0') {
      if (v.length >= 2 && v.charAt(1) !== '1') { return PH_START; }
      if (v.length >= 3 && !/[3-9]/.test(v.charAt(2))) { return PH_START; }
    } else if (c !== '0' && c !== '8') { return PH_START; }
    if (/^01[0-9]{9}$/.test(v)) { var r = bdPhone(v); if (!r.ok) { return r.msg; } }
    return '';
  }
  function validate() {
    var first = null;
    function bad(f, m) { setErr(f, m); if (!first) { first = f; } }
    clearErrs();
    var name = $('#glw-name').value.trim(), pr = bdPhone($('#glw-phone').value), phone = pr.ok ? pr.phone : '', addr = $('#glw-address').value.trim();
    if (name.length < 2) { bad('name', 'আপনার নাম লিখুন।'); }
    if (!pr.ok) { bad('phone', pr.msg); }
    if (addr.length < 6) { bad('address', 'সম্পূর্ণ ঠিকানা লিখুন।'); }
    if (!S.dist) { bad('district', 'জেলা নির্বাচন করুন।'); }
    else if (!S.thana) { bad('thana', 'থানা নির্বাচন করুন।'); }
    if (first) {
      var el = $('#glw-' + first);
      if (el) { try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus({ preventScroll: true }); } catch (x) { } }
      return null;
    }
    return { name: name, phone: phone, address: addr };
  }
  function send(payload) {
    var ctl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) { ctl.abort(); } }, 40000);
    return fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(payload), signal: ctl ? ctl.signal : undefined, redirect: 'follow' })
      .then(function (r) { clearTimeout(timer); return r.text(); })
      .then(function (t) { try { return JSON.parse(t); } catch (e) { throw new Error('bad response'); } });
  }
  function onSubmit(e) {
    e.preventDefault();
    if (S.busy || S.done) { return; }
    var v = validate();
    if (!v) { return; }
    S.busy = true;
    var btn = $('#glw-submit'), t = $('#glw-submit-t'), label = t.textContent;
    btn.disabled = true; t.textContent = 'অর্ডার হচ্ছে…';
    var cc = calc();
    var snapshot = S.items.map(function (i) { return { id: i.id, qty: i.qty, name: i.name, variant: i.variant, img: i.img, unit: i.unit }; });
    send({
      v: 1, items: S.items.map(function (i) { return { variant_id: i.id, qty: i.qty }; }),
      name: v.name, phone: v.phone, address: v.address, district: S.dist.n, thana: S.thana.n,
      district_bn: S.dist.b, thana_bn: S.thana.b, note: $('#glw-note').value, hp: $('#glw-hp').value,
      t: Date.now() - S.t0, coupon: (S.rule && cc.cp && cc.cp.ok) ? S.rule.code : '',
      meta: { landing: ss('glwc_land', undefined) || location.href, referrer: ss('glwc_ref', undefined), source: ss('glwc_src', undefined) || 'Direct', event_id: S.eid, fbp: cookie('_fbp'), fbc: cookie('_fbc') }
    }).then(function (res) {
      if (res && res.ok) { success(res, v, snapshot); return; }
      S.busy = false; btn.disabled = false; t.textContent = label;
      var f = res && res.error;
      if (f === 'name' || f === 'phone' || f === 'address' || f === 'district' || f === 'thana') { setErr(f, res.message); }
      else { formErr((res && res.message) ? res.message : 'অর্ডার সম্পন্ন করা যায়নি।'); }
    }).catch(function () {
      S.busy = false; btn.disabled = false; t.textContent = label;
      formErr('ইন্টারনেট সংযোগ পরীক্ষা করে আবার চেষ্টা করুন। (অর্ডার হয়ে থাকলে আবার দিলেও ডুপ্লিকেট হবে না।)');
    });
  }

  /* ---------- success ---------- */
  function success(res, v, items) {
    S.done = true; S.busy = false;
    var d = new Date(), months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var h = '<div class="glw-head"><span class="glw-head-ic ok"><svg class="i" width="22" height="22"><use href="#gi-ok"/></svg></span><span class="glw-head-tx"><strong>অর্ডার সফল হয়েছে!</strong><small>ধন্যবাদ, আপনার অর্ডার গ্রহণ করা হয়েছে</small></span><button type="button" class="glw-x" data-close aria-label="Close"><svg class="i" width="18" height="18"><use href="#gi-x"/></svg></button></div><div class="glw-body">';
    h += '<div class="glw-meta"><div><small>অর্ডার নম্বর</small><strong>' + esc(res.order_name) + '</strong></div><div><small>তারিখ</small><strong>' + months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear() + '</strong></div><div><small>পেমেন্ট</small><strong>Cash on delivery</strong></div></div><div class="glw-items">';
    items.forEach(function (it) {
      h += '<div class="glw-item"><span class="glw-thumb">' + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '') + '</span><span class="glw-item-i"><span class="glw-item-n">' + esc(it.name) + '</span><span class="glw-item-v">' + (it.variant ? esc(it.variant) + ' · ' : '') + 'পরিমাণ: ' + it.qty + '</span></span><span class="glw-item-p">' + money(it.unit * it.qty) + '</span></div>';
    });
    h += '</div><div class="glw-sum"><div class="glw-sum-r"><span>Subtotal</span><span>' + money(res.subtotal) + '</span></div>' +
      (res.discount > 0 ? '<div class="glw-sum-r glw-sum-d"><span>Quantity discount</span><span>−' + money(res.discount) + '</span></div>' : '') +
      (res.coupon_discount > 0 ? '<div class="glw-sum-r glw-sum-d"><span>Coupon (' + esc(res.coupon) + ')</span><span>−' + money(res.coupon_discount) + '</span></div>' : '') +
      '<div class="glw-sum-r"><span>Shipping (' + esc(res.zone_bn) + ')</span><span>' + (res.shipping > 0 ? money(res.shipping) : 'Free') + '</span></div>' +
      '<div class="glw-sum-r glw-sum-t"><span>Total</span><span>' + money(res.total) + '</span></div></div>' +
      '<div class="glw-addr"><small>ডেলিভারি ঠিকানা</small><strong>' + esc(v.name) + ' · ' + esc(v.phone) + '</strong><span>' + esc(v.address) + ', ' + esc(S.thana.n) + ', ' + esc(S.dist.n) + '</span></div>' +
      '<p class="glw-tyt">আমাদের প্রতিনিধি শীঘ্রই কল করে অর্ডার কনফার্ম করবেন। প্রোডাক্ট হাতে পেয়ে টাকা পরিশোধ করুন।</p></div>' +
      '<div class="glw-foot glw-foot-ty"><button type="button" class="glw-submit" data-close>শপিং চালিয়ে যান</button>' + (WA ? '<a class="glw-wa" target="_blank" rel="noopener" href="https://wa.me/' + esc(WA) + '">WhatsApp-এ যোগাযোগ করুন</a>' : '') + '</div>';
    $('#glw-form').hidden = true;
    var ty = $('#glw-ty'); ty.innerHTML = h; ty.hidden = false;
    dlg.scrollTop = 0;
    if (!res.dup) { track('buy', { items: items, value: res.total, shipping: res.shipping, order: res.order_name, event_id: S.eid }); }
    if (S.src === 'cart') { try { fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }); } catch (e) { } }
  }

  /* ---------- wiring ---------- */
  var ddD, ddT;
  function wire() {
    ddT = dropdown('#glw-dd-thana', function () { return S.dist ? S.dist.t : []; }, function (it) { S.thana = it; setErr('thana', ''); totals(); });
    ddD = dropdown('#glw-dd-district', function () { return GEO; }, function (it) { S.dist = it; S.thana = null; ddT.reset(); setErr('district', ''); setErr('thana', ''); totals(); });
    $('#glw-items').addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-a]');
      if (!btn) { return; }
      var i = parseInt(btn.closest('.glw-item').getAttribute('data-i'), 10), it = S.items[i];
      if (!it) { return; }
      var a = btn.getAttribute('data-a');
      if (a === 'plus') { it.qty = Math.min(50, it.qty + 1); }
      else if (a === 'minus') { it.qty = Math.max(1, it.qty - 1); }
      else { S.items.splice(i, 1); }
      refresh();
    });
    var ph = $('#glw-phone');
    ph.addEventListener('input', function () {
      var v = toEn(ph.value).replace(/[^0-9+]/g, ''), m = v.match(/^(?:(?:\+|00)?88)(01[3-9][0-9]{8})$/);
      if (m) { v = m[1]; }   /* pasted +8801XXXXXXXXX / 8801XXXXXXXXX -> 01XXXXXXXXX */
      if (v !== ph.value) { ph.value = v; }
      setErr('phone', phLive(v));
    });
    ph.addEventListener('blur', function () { if (ph.value) { var r = bdPhone(ph.value); setErr('phone', r.ok ? '' : r.msg); } });
    ['name', 'address'].forEach(function (f) { $('#glw-' + f).addEventListener('input', function () { setErr(f, ''); }); });
    $('#glw-cp-apply').addEventListener('click', cpApplyClick);
    $('#glw-coupon').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); cpApplyClick(); } });
    $('#glw-cp-rm').addEventListener('click', function () { S.rule = null; cpMsg(''); totals(); });
    $('#glw-form').addEventListener('submit', onSubmit);
    root.addEventListener('click', function (e) {
      if (e.target === root) { close(); return; }
      if (e.target.closest('[data-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('open')) { close(); } });
  }

  /* ---------- triggers (work for re-rendered cart drawer too) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var pb = t.closest('[data-glwc="product"]');
    if (pb) { e.preventDefault(); e.stopPropagation(); if (!pb.disabled) { open('product', pb); } return; }
    var cb = t.closest('button[name="checkout"], a[href^="/checkout"], input[name="checkout"]');
    if (cb) { e.preventDefault(); e.stopPropagation(); if (!cb.disabled) { open('cart'); } }
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') { e.preventDefault(); e.stopPropagation(); open('cart'); }
  }, true);

  /* labels of the native checkout buttons -> COD wording (also after cart drawer re-renders) */
  var LABEL = 'ক্যাশ অন ডেলিভারিতে অর্ডার করুন';
  function relabel() {
    var list = document.querySelectorAll('button[name="checkout"]');
    for (var i = 0; i < list.length; i++) { if (list[i].getAttribute('data-glwc-l') !== '1') { list[i].textContent = LABEL; list[i].setAttribute('data-glwc-l', '1'); } }
  }
  relabel();
  if (window.MutationObserver) { new MutationObserver(function () { relabel(); }).observe(document.body || document.documentElement, { childList: true, subtree: true }); }
})();
